import * as Cesium from "cesium";
import { Camera, Scene } from "cesium";
import PerspectiveFrustum from "cesium/Source/Core/PerspectiveFrustum";
import { View } from "ol";
import { getTransform } from "ol/proj";
import Projection from "ol/proj/Projection";

function calcDistanceForResolution(
  resolution: number,
  latitude: number,
  scene: Scene,
  projection: Projection,
): number {
  const { canvas, camera } = scene;
  const { fovy } = camera.frustum as PerspectiveFrustum;
  const metersPerUnit = projection.getMetersPerUnit() ?? 0;
  const visibleMapUnits = resolution * canvas.clientHeight;
  const relativeCircumference = Math.cos(Math.abs(latitude));
  const visibleMeters = visibleMapUnits * metersPerUnit * relativeCircumference;
  const requiredDistance = visibleMeters / 2 / Math.tan(fovy / 2);
  return requiredDistance;
}

// eslint-disable-next-line @typescript-eslint/require-await
export async function olViewToCesium(
  olView: View,
  camera: Camera,
  scene: Scene,
): Promise<void> {
  const toLonLat = getTransform(olView.getProjection(), "EPSG:4326");
  const olCenter = olView.getCenter();
  if (!olCenter) return;
  const centerLonLat = toLonLat(olCenter);
  const carto = new Cesium.Cartographic(
    Cesium.Math.toRadians(centerLonLat[0]),
    Cesium.Math.toRadians(centerLonLat[1]),
  );
  // const samples = await Cesium.sampleTerrainMostDetailed(
  //   scene.terrainProvider,
  //   [carto],
  // );
  // carto.height = samples[0].height;
  const destination = Cesium.Ellipsoid.WGS84.cartographicToCartesian(carto);
  camera.setView({
    destination,
  });
  const resolution = olView.getResolution();
  if (!resolution) return;
  const distance = calcDistanceForResolution(
    resolution,
    Cesium.Math.toRadians(centerLonLat[1]),
    scene,
    olView.getProjection(),
  );
  camera.moveBackward(distance);
}
